import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[600px] md:h-[700px] flex items-center overflow-hidden" aria-labelledby="hero-title">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20background%20with%20rich%20deep%20emerald%20green%20and%20black%20gradient%2C%20mysterious%20atmospheric%20texture%2C%20cinematic%20noir%20aesthetic%2C%20subtle%20dramatic%20lighting%20with%20soft%20highlights%2C%20dark%20minimalist%20composition%2C%20editorial%20fine%20art%20quality%2C%20no%20text%2C%20no%20people&width=1920&height=900&seq=hero-bg-home-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
            <i className="ri-fire-line text-accent-400 text-sm"></i>
            <span className="text-xs font-medium text-accent-300 whitespace-nowrap">今日热门 · 实时更新</span>
          </div>

          <h1 id="hero-title" className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight tracking-tight">
            最新吃瓜网红爆料
            <br />
            <span className="text-accent-400">每日大赛</span>在线观看
          </h1>

          <p className="mt-4 md:mt-6 text-base md:text-lg text-white/60 max-w-xl leading-relaxed">
            一键直达全网独家黑料资源，明星八卦、网红翻车、娱乐圈内幕，每天不间断更新。
          </p>

          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/yiqu"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-accent-500/30 backdrop-blur-sm border border-accent-400/40 text-white font-medium text-sm hover:bg-accent-500/50 cursor-pointer transition-all whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg"></i>
              进入一区
            </Link>
            <Link
              to="/category/erqu"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white font-medium text-sm hover:bg-white/20 cursor-pointer transition-all whitespace-nowrap"
            >
              <i className="ri-flashlight-line text-lg"></i>
              进入二区
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Brand Slogan */}
      <div className="absolute bottom-0 left-0 right-0 pointer-events-none">
        <p className="font-heading text-6xl md:text-8xl lg:text-9xl font-black text-white/6 leading-none tracking-tighter pl-6 md:pl-10 pb-4 md:pb-6 select-none whitespace-nowrap overflow-hidden">
          51黑料网 · 吃瓜第一站
        </p>
      </div>
    </section>
  );
}